import React from "react";
import {useCreativeStudioTypesDetailsQueryQuery} from "../../generated/graphql"; 
import {GraphQlSelect} from "./GraphQlSelect";
import { GraphQlSelectId } from "./GraphQlSelectId";

export const CreativeStudioTypeDetailSelect = (props) => {
    const query = useCreativeStudioTypesDetailsQueryQuery({variables:{creativeStudioTypeId:props.creativeStudioType??null}});
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="name" />:<GraphQlSelect queryResult={query} {...props}  labelField="name" />;
}

